import {
    QuestionAnswer,
    InsertEmoticon,
    Quiz,
    Poll,
    TextFields,
    Cloud,
    Flaky,
    TouchApp,
    Photo, QuestionMark, Mic, FormatListNumbered, PanTool, Link, WbIncandescent, Rtt,
    PhotoAlbum, Insights
} from "@mui/icons-material";

import {THEME_CONFIG} from "../../config";

const {homeQuestionIcon} = THEME_CONFIG

const hasIcon = (icon) => homeQuestionIcon ? icon : null

const questionType = {
    qna: {
        text: 'Q&A',
        icon: hasIcon(<QuestionAnswer/>)
    },
    toolpress: {
        text: 'Toolpress',
        icon: hasIcon(<QuestionAnswer/>)
    },
    quiz: {
        text: 'Quiz',
        icon: hasIcon(<Quiz/>)
    },
    poll: {
        text: 'Sondaggio',
        icon: hasIcon(<Poll/>)
    },
    colorPoll: {
        text: 'Sondaggio colorato',
        icon: <WbIncandescent/>
    },
    multiPoll: {
      text: 'Sondaggio',
      icon: hasIcon(<Poll/>)
    },
    reorder: {
        text: 'Riordinamento',
        icon: hasIcon(<FormatListNumbered/>)
    },
    wordcloud: {
        text: 'Wordcloud',
        icon: hasIcon(<Cloud/>)
    },
    sentiment: {
        text: 'Sentiment',
        icon: hasIcon(<InsertEmoticon/>)
    },
    siNo: {
        text: 'Sí/No',
        icon: hasIcon(<Flaky/>)
    },
    clickTo:{
        text: 'Click To',
        icon: hasIcon(<TouchApp/>)
    },
    links:{
        text: 'Click To',
        icon: hasIcon(<Link/>)
    },
    text: {
        text: 'Testo',
        icon: hasIcon(<Rtt/>)
    },
    color:{
        text: 'Colora smartphone',
        icon: hasIcon(<WbIncandescent />)
    },
    sendPhoto:{
        text: "Invio foto",
        icon: hasIcon(<Photo/>)
    },
    audio:{
        text: "Invio audio",
        icon: hasIcon(<Mic/>)
    },
    reserveSpot: {
        text: "Prenota il tuo posto!",
        icon: hasIcon(<PanTool/>)
    },
    photoGallery: {
        text: "Photo gallery",
        icon: hasIcon(<PhotoAlbum/>)
    },
    altro:{
        text: "Altro",
        icon: hasIcon(<Insights/>)
    },
}

export default questionType